// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__mT7tf","emails":"CreateEditClinics_emails__3ac1j","emailTagLabel":"CreateEditClinics_emailTagLabel__1Jqqg"};